import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "../src/lang/index";
import "../theme/index.css";

import * as filters from "./utils/filter";
import * as directives from "@/directives";

// import "@/mock/index";
import { message } from "./utils/message.js";
// import tableHeight from "@/directives/";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import "@/assets/css/base.less";
// import { login } from "@/api";
import cookies from "./utils/cookies"; // todo

import "./permission";
import { commonApi } from "@/api";

Vue.prototype.$commonApi = commonApi;

Vue.use(VXETable);

// 全局自定义指令
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
});
// 全局引入过滤器
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

import {
    Button,
    Container,
    Header,
    Aside,
    Main,
    Row,
    Col,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Dialog,
    FormItem,
    Form,
    Select,
    Option,
    Input,
    CheckboxGroup,
    Checkbox,
    RadioGroup,
    Radio,
    Breadcrumb,
    BreadcrumbItem,
    Divider,
    Progress,
    Table,
    TableColumn,
    Popover,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Tooltip,
    Message,
    Loading,
    Tabs,
    TabPane,
    Tag,
    Drawer,
    MessageBox,
    Collapse,
    CollapseItem,
} from "element-ui";

Vue.config.productionTip = false;
Vue.use(Container).use(Header).use(Aside).use(Main);
Vue.use(Row).use(Col);
Vue.use(Menu).use(Submenu).use(MenuItem).use(MenuItemGroup);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Form)
    .use(FormItem)
    .use(CheckboxGroup)
    .use(Checkbox)
    .use(Input)
    .use(RadioGroup)
    .use(Radio)
    .use(Select)
    .use(Option);
Vue.use(Breadcrumb).use(BreadcrumbItem);
Vue.use(Divider);
Vue.use(Progress);
Vue.use(Table).use(TableColumn);
Vue.use(Popover);
Vue.use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Tooltip);
Vue.use(Tabs).use(TabPane);
Vue.use(Tag);
Vue.use(Loading.directive);
Vue.use(Drawer);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
// Vue.use(ElementUI);
Vue.prototype.$message = message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$msgbox = MessageBox;
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
    methods: {},
    created() {},
    mounted() {
        // this.$store.commit("userinfo/SET_TOKEN");
        // console.log("main");
        // login({
        //   email: "avtest48@123.com",
        //   //   email: "avtest51@123.com",
        //   //   email: "avtest54@123.com",
        //   //   email: "",
        //   //   pwd: "123456789",
        //   pwd: "123456",
        // }).then((res) => {
        //   console.log(res, "resass");
        //   if (res.code === 200) {
        //     cookies.set("access-token", res.token, { expires: 7, path: "/" });
        //   }
        // });
    },
}).$mount("#app");
